import { Box, Skeleton } from '@mui/material';
import React from 'react';

import { DATA_TEST } from '../enums';

interface ILoadingBlockProps {
  numberOfRows: number;
}

export const LoadingBlock = ({ numberOfRows }: ILoadingBlockProps) => {
  const [loadingRows, setLoadingRows] = React.useState<React.ReactNode[]>([]);
  React.useEffect(() => {
    const newLoadingRows: React.ReactNode[] = [];
    for (let i = 0; i < numberOfRows; i++) {
      newLoadingRows.push(
        <Skeleton key={i} data-test={DATA_TEST.menu_loading_indicator} variant="rectangular" height={20} />
      );
    }
    setLoadingRows(newLoadingRows);
  }, [numberOfRows]);

  return (
    <Box display="flex" data-test={DATA_TEST.loading_block_indicator} flexDirection="column" width="100%" gap={1}>
      {loadingRows}
    </Box>
  );
};
